import type { FC } from "react"
import React from "react"

import { useSetRecoilState, useRecoilValue } from "recoil"

import { ReactComponent as RotateIcon } from "@svg/rotate-right-outlined.svg"

import { IconButton } from "."
import { panelSelectionState } from "../state/elements/panels"
import { panelSelectionRotationState } from "../state/elements/panels/rotating"
import { phaseState } from "../state/phase"

export const RotatePanelsButton_Internal: FC = () => {
  const rotatePanel = useSetRecoilState(panelSelectionRotationState)
  const currentPhase = useRecoilValue(phaseState)
  const selectedPanels = useRecoilValue(panelSelectionState)

  return (
    <>
      {currentPhase === `Panel Placement` && selectedPanels.size > 0 ? (
        <IconButton
          title="Rotate Selected Panels"
          onClick={() => rotatePanel({ willReorient90: true })}
        >
          <RotateIcon />
        </IconButton>
      ) : null}
    </>
  )
}

export const RotatePanelsButton = React.memo(RotatePanelsButton_Internal)

export default RotatePanelsButton
